import { useState } from "react";
import { useLocation } from "react-router-dom";
import useUser from "../../hooks/context/userHook";
import useConsent from "../../hooks/api/useConsent";
import { useCheckUserOnboarding } from "../../hooks/api/useCheckUserOnboarding";
import { shouldShowConsentGate } from "../../utils/consentModel";
import { CONSENT_SOURCE_APP_GATE } from "../../data/constants/legalPolicies";
import LegalConsentModal from "./LegalConsentModal";

/**
 * Mounted once near the app root. For an already-authorized user who has not
 * consented, shows a blocking modal. Never appears on onboarding routes, and
 * fails open if the status read errors (see design §8).
 */
const ConsentGate = () => {
  const { userId } = useUser();
  const { pathname } = useLocation();
  const { isAuthorized } = useCheckUserOnboarding(userId || undefined, { skipNavigation: true });
  const { needsConsent, isLoading, statusError, mutate } = useConsent();
  const [dismissed, setDismissed] = useState(false);

  const show =
    !dismissed &&
    shouldShowConsentGate({ userId, isAuthorized, pathname, isLoading, statusError, needsConsent });

  if (!show) return null;

  return (
    <LegalConsentModal
      open
      source={CONSENT_SOURCE_APP_GATE}
      onComplete={() => {
        setDismissed(true);
        mutate();
      }}
    />
  );
};

export default ConsentGate;
